/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetOrganizationsWithAccounts200ResponseInner
 */
export interface GetOrganizationsWithAccounts200ResponseInner {
    /**
     * 組織コード
     * @type {string}
     * @memberof GetOrganizationsWithAccounts200ResponseInner
     */
    organizationCode: string;
    /**
     * 組織名
     * @type {string}
     * @memberof GetOrganizationsWithAccounts200ResponseInner
     */
    organizationName: string;
    /**
     * 無線グループID
     * @type {string}
     * @memberof GetOrganizationsWithAccounts200ResponseInner
     */
    companyCode?: string;
    /**
     * 無線グループ名
     * @type {string}
     * @memberof GetOrganizationsWithAccounts200ResponseInner
     */
    groupName?: string;
    /**
     * 会社ID
     * @type {string}
     * @memberof GetOrganizationsWithAccounts200ResponseInner
     */
    companyId?: string;
    /**
     * 会社名
     * @type {string}
     * @memberof GetOrganizationsWithAccounts200ResponseInner
     */
    companyName?: string;
    /**
     * 営業所ID
     * @type {string}
     * @memberof GetOrganizationsWithAccounts200ResponseInner
     */
    salesOfficeId?: string;
    /**
     * 営業所名
     * @type {string}
     * @memberof GetOrganizationsWithAccounts200ResponseInner
     */
    salesOfficeName?: string;
    /**
     * アカウントID
     * @type {string}
     * @memberof GetOrganizationsWithAccounts200ResponseInner
     */
    accountId: string;
    /**
     * アカウント状態 (1:未連携, 2:連携済)
     * @type {number}
     * @memberof GetOrganizationsWithAccounts200ResponseInner
     */
    status: number;
    /**
     * アカウント名
     * @type {string}
     * @memberof GetOrganizationsWithAccounts200ResponseInner
     */
    accountName: string;
    /**
     * メールアドレス
     * @type {string}
     * @memberof GetOrganizationsWithAccounts200ResponseInner
     */
    email: string;
    /**
     * 利用者種別 (1:全権管理者, 2:組織管理者, 3:一般)
     * @type {number}
     * @memberof GetOrganizationsWithAccounts200ResponseInner
     */
    role: number;
    /**
     * 追加権限リスト（1: 個人情報閲覧、2: 配車、3: マスター登録、4: 返金）
     * @type {Array<number>}
     * @memberof GetOrganizationsWithAccounts200ResponseInner
     */
    permissions: Array<number>;
    /**
     * アカウント連携種別 (0: アカウント登録, 1: 所属追加)
     * @type {number}
     * @memberof GetOrganizationsWithAccounts200ResponseInner
     */
    type: number;
}

/**
 * Check if a given object implements the GetOrganizationsWithAccounts200ResponseInner interface.
 */
export function instanceOfGetOrganizationsWithAccounts200ResponseInner(value: object): value is GetOrganizationsWithAccounts200ResponseInner {
    if (!('organizationCode' in value) || value['organizationCode'] === undefined) return false;
    if (!('organizationName' in value) || value['organizationName'] === undefined) return false;
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('accountName' in value) || value['accountName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('permissions' in value) || value['permissions'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function GetOrganizationsWithAccounts200ResponseInnerFromJSON(json: any): GetOrganizationsWithAccounts200ResponseInner {
    return GetOrganizationsWithAccounts200ResponseInnerFromJSONTyped(json, false);
}

export function GetOrganizationsWithAccounts200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrganizationsWithAccounts200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'organizationCode': json['organization_code'],
        'organizationName': json['organization_name'],
        'companyCode': json['company_code'] == null ? undefined : json['company_code'],
        'groupName': json['group_name'] == null ? undefined : json['group_name'],
        'companyId': json['company_id'] == null ? undefined : json['company_id'],
        'companyName': json['company_name'] == null ? undefined : json['company_name'],
        'salesOfficeId': json['sales_office_id'] == null ? undefined : json['sales_office_id'],
        'salesOfficeName': json['sales_office_name'] == null ? undefined : json['sales_office_name'],
        'accountId': json['account_id'],
        'status': json['status'],
        'accountName': json['account_name'],
        'email': json['email'],
        'role': json['role'],
        'permissions': json['permissions'],
        'type': json['type'],
    };
}

export function GetOrganizationsWithAccounts200ResponseInnerToJSON(json: any): GetOrganizationsWithAccounts200ResponseInner {
    return GetOrganizationsWithAccounts200ResponseInnerToJSONTyped(json, false);
}

export function GetOrganizationsWithAccounts200ResponseInnerToJSONTyped(value?: GetOrganizationsWithAccounts200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organization_code': value['organizationCode'],
        'organization_name': value['organizationName'],
        'company_code': value['companyCode'],
        'group_name': value['groupName'],
        'company_id': value['companyId'],
        'company_name': value['companyName'],
        'sales_office_id': value['salesOfficeId'],
        'sales_office_name': value['salesOfficeName'],
        'account_id': value['accountId'],
        'status': value['status'],
        'account_name': value['accountName'],
        'email': value['email'],
        'role': value['role'],
        'permissions': value['permissions'],
        'type': value['type'],
    };
}

